import { HttpClient } from '@core/gateways'
import { UnexpectedError } from '@core/models/errors'
import { setupIntranetV2ApiClient } from '@core/proxies/apis/intranet-v2'
import { HttpStatusCode } from '@core/types/gateways'
import { ObterConsultaTransitos } from '@core/types/services'

export const obterConsultaTransitos: ObterConsultaTransitos = async input => {
  const response = await HttpClient.of(setupIntranetV2ApiClient()).request({
    url: '/consulta-transitos',
    method: 'GET',
    params: input?.params
  })

  switch (response.statusCode) {
    case HttpStatusCode.ok:
      return response.body
    default:
      throw new UnexpectedError()
  }
}
